import { render } from "./ProofreadingDocumentPage.vue?vue&type=template&id=c6923bc6&scoped=true&ts=true"
import script from "./ProofreadingDocumentPage.vue?vue&type=script&lang=ts"
export * from "./ProofreadingDocumentPage.vue?vue&type=script&lang=ts"

import "./ProofreadingDocumentPage.vue?vue&type=style&index=0&id=c6923bc6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6923bc6"]])

export default __exports__